package com.dotdrives.model

import kotlinx.serialization.Serializable

@Serializable
data class DrivePhaseStats(val phaseId: String, val totalCount: Long, val askTotal: Double)

@Serializable
data class DriveFinancialTotals(val proposedAmount: Double = 0.0, val pledgedAmount: Double = 0.0, val receivedAmount: Double = 0.0)

@Serializable
data class DriveBoardSnapshot(
    val cards: List<DriveSummary> = emptyList(),
    val phaseStats: List<DrivePhaseStats> = emptyList(),
    val totalCount: Long = 0,
    val tags: List<String> = emptyList(),
    val financials: List<DriveFinancials> = emptyList(),
    val financialTotals: DriveFinancialTotals? = null,
)

/** Dates are inclusive UTC calendar dates. Null bounds mean all available history. */
data class DriveSnapshotRequest(
    val templateId: String,
    val query: String? = null,
    val stewardUserId: String? = null,
    val targetId: String? = null,
    val tag: String? = null,
    val giverType: String? = null,
    val phaseId: String? = null,
    val offset: Int = 0,
    val closed: Boolean = false,
    val startDate: String? = null,
    val endDate: String? = null,
)
